module.exports = __webpack_public_path__ + "static/media/totvs.67bb2e25.jpg";